export default __webpack_public_path__ + "static/media/unstaking-step-three-bite.b6551d50.svg";